/**
 * Microsoft PowerPoint 아이콘 SVG
 *
 * 크기 조절: className으로 w-*, h-* 클래스 사용
 * @example
 * ```tsx
 * <MicrosoftPowerPointIcon className="w-8 h-8" />
 * <MicrosoftPowerPointIcon className="w-12 h-12" />
 * ```
 */
export function MicrosoftPowerPointIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-label="Microsoft PowerPoint icon"
      role="img"
    >
      <title>Microsoft PowerPoint</title>
      <g id="Microsoft PowerPoint">
        <g id="Vector">
          <path
            d="M18.536 2.5V5.32554C21.936 5.34429 25.893 5.29099 29.29 5.34133C29.932 5.34133 29.96 5.90189 29.968 6.3914C30.022 12.2556 29.955 18.2887 30 24.1559C29.988 24.3868 29.994 25.2415 29.987 25.4842C29.965 26.2965 29.553 26.332 28.73 26.3567C28.598 26.3567 28.21 26.3626 28.082 26.3685C24.901 26.3527 21.72 26.3596 18.536 26.3596V29.5L2 26.9883C2 19.6628 2 12.3395 2 5.01861L18.536 2.5Z"
            fill="#D33922"
          />
          <path
            d="M18.536 6.26705H29.036V25.4132H18.536V22.9084H26.17V21.6501H18.536V20.0809H26.17V18.8255H18.539C18.539 18.2097 18.539 17.5949 18.533 16.98C19.1575 17.2024 19.8245 17.2846 20.4853 17.2205C21.1461 17.1565 21.7841 16.9479 22.353 16.6099C22.9328 16.2339 23.4131 15.7266 23.7538 15.1302C24.0946 14.5337 24.286 13.8656 24.312 13.1814C22.912 13.1715 21.519 13.1755 20.126 13.1755C20.126 11.8096 20.142 10.4447 20.097 9.08173C19.575 9.18043 19.054 9.28899 18.535 9.39853V6.26804"
            fill="white"
          />
          <path
            d="M20.7664 8.42443C21.8511 8.4915 22.8741 8.94579 23.6443 9.70252C24.4146 10.4592 24.8795 11.4667 24.9524 12.5369C23.5524 12.5527 22.1594 12.5468 20.7634 12.5468C20.7634 11.172 20.7634 9.79624 20.7634 8.42443"
            fill="#D33922"
          />
          <path
            d="M7.09995 10.795C8.82695 10.8769 10.9199 10.12 12.3519 11.398C13.7229 13.0403 13.3599 16.0602 11.3279 17.0422C10.5891 17.3309 9.78815 17.4301 8.99995 17.3304C8.99995 18.5581 8.99395 19.7858 8.99995 21.0126C8.36995 20.9593 7.73695 20.906 7.10695 20.8556C7.07795 17.5001 7.07195 14.1446 7.10695 10.7891"
            fill="white"
          />
          <path
            d="M8.99364 12.4925C9.62064 12.4639 10.3936 12.3514 10.8196 12.9317C10.99 13.2477 11.0824 13.5989 11.0896 13.9567C11.0967 14.3146 11.0183 14.6691 10.8606 14.9914C10.4976 15.6378 9.67764 15.5757 9.04464 15.6507C8.97764 14.5986 8.98464 13.5476 8.99364 12.4925Z"
            fill="#D33922"
          />
        </g>
      </g>
    </svg>
  );
}
